import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ModuleCompletedView } from '../../views';

export const exerciseData41Completed: ExerciseData = {
    ExerciseView: Module4Exercise1Completed,
    dataKeys: [],
    questions: [],
};

function Module4Exercise1Completed({ onContinue }: ExerciseViewProps) {
    return (
        <ModuleCompletedView onContinue={onContinue}>
            <div>
                Du har kigget på, hvad der er vigtigt for dig (dine værdier), og
                om du bruger din tid på dem.
            </div>
            <div>
                Måske synes du, at øvelsen var lidt svær - det er helt okay! Det
                kan kræve noget at få hånd om sine værdier. Det kan være en god
                idé at snakke med en ven eller din psykolog om øvelsen. Når du
                sætter ord på dine tanker og deler dem med en anden, kan det
                nemlig hjælpe dig med at se tingene tydeligere.
            </div>
        </ModuleCompletedView>
    );
}
